import React from 'react';
import { connect } from 'react-redux';

import ActiveFilters from '../../../../../components/search/plans_table/Filters/ActiveFilters';
import HospitalExpenseFilter from './components/HospitalExpenseFilter';

import styles from './styles.module.css';
import CovidCoverageFilter from './components/CovidCoverageFilter';
import AgeRangeFilter from './components/AgeRangeFilter';
import BenefitsCoverageFilter from './components/BenefitsCoverageFilter';
import ProviderFilter from './components/ProviderFilter';

export const Filters = (props) => {
  return (
    <div className={styles.filtersContainer}>
        <div className={styles.filterTitle}>Filtrar</div>
        {!props.mobile && <ActiveFilters />}
        <HospitalExpenseFilter />
        <ProviderFilter />
        <AgeRangeFilter />
        <BenefitsCoverageFilter />
        <CovidCoverageFilter />
    </div>
  )
}

const mapStateToProps = (state) => ({
  mobile: state.mobile.mobileActive,
});

export default connect(mapStateToProps, {
})(Filters);



// WEBPACK FOOTER //
// ./src/views/v2/search/components/filter/index.jsx